import { useQuery } from '@tanstack/react-query'
import { projectsApi } from '@/api/projects'

const TECHNOLOGIES_KEY = ['technologies'] as const

export function useTechnologies() {
  return useQuery({
    queryKey: TECHNOLOGIES_KEY,
    queryFn: projectsApi.getTechnologies,
    staleTime: Infinity,
  })
}
